import { inject, Injectable } from '@angular/core';
import { JourneyOperationResult, ChatOperationResult, BackendRequest, RequestType, BackendResponse, InviteOperationResult, GJData, GJDataMember } from '../amplify/types';
import { AmplifyService } from './amplify.service';
import { JourneyChatMessage } from '../utils/commonTypes';
import { Utils } from '../utils/amplify-utils';
import { AppLogUtils } from '../utils/log-utils';
import { API_ENDPOINT, ApiUtils } from '../utils/api/api-utils';
import { ApiResultTypes } from '../public-api';
import { Group, ChatMessage } from '../utils/group-data-types';

@Injectable({
  providedIn: 'root'
})
export class GroupJourneyService {

  
  private amplifyService = inject(AmplifyService);
  private amplifyClient = this.amplifyService.getClient();


  // public async loadUserJourneys(productId:string): Promise<GJData[]>{
  //   const user = this.userService.currentUser();
  //   AppLogUtils.info(`loadUserJourneys userId: [${user.id}] productId:[${productId}]`);

  //   //Find all groups matching the product

  //   const resultGroupIds = await this.amplifyClient.models.UserGroup.listUserGroupByUserIdAndProductIdRef(
  //     { userId: user.id,productIdRef:{eq:productId}},
  //     { selectionSet: ['groupId']},
  //   );
  //   const gjList:GJData[]=[]
  //   const groups = Utils.getDataFromResult(resultGroupIds.data, resultGroupIds.errors, 'UserGroup.listUserGroupByUserIdAndProductIdRef');
  //   if(!groups){return gjList;}
    
  //   for(const g of groups){
  //     const group = await this.getGroup(g.groupId,true);
  //     if(group){
  //       gjList.push({
  //         id:group.id,
  //         productId:group.productId,
  //         name:group.name,
  //         owner:group.owner,
  //         members:group.members
  //       });
  //     }
  //   }
  //   return gjList;
  // }

  public async loadGroupsByProductId(productId:string): Promise<GJData[]>{
    const apiEndpoint = `${API_ENDPOINT}/group/usergroups/${productId}`;
    const response = await ApiUtils.apiCall<
      {
        result: ApiResultTypes,
        groups:Group[]
      }
    >(
      'get',
      apiEndpoint,
    );
    if(response.result == ApiResultTypes.SUCCESS){
      const groups:GJData[] = response.groups.map(g=>{
        return {
          id:g.id,
          name:g.name,
          owner:'',
          ownerUserId: g.members.find(m=>m.leader===true)?.id??'',
          productId: productId,
          members: g.members.map(m=>{
            return {
              id:'',
              userId: m.id,
              sub: '',
              name:m.name,
              avatar:''
            } as GJDataMember;
          })
        } as GJData;
      });
      return groups;
    }else{
      return [];
    }

  }
  
  // public async loadUserJourneys(productId?:string): Promise<GJData[]>{
  //   if(!productId){
  //     AppLogUtils.info(`No product id => no user journeys to load`);
  //     return [];
  //   }
  //   console.log(`loadUserJourneys productId:[${productId}]`);
  //   AppLogUtils.info(`loadUserJourneys productId:[${productId}]`);
  //   const result = await this.getUserJourneysFromBackend(productId);
  //   // console.log(`Journeys result`,result);
  //   //TEMPORARY FIX => remove null journeys (need to fix the backend service)
  //   if(!result.journeyList){
  //     return [];
  //   }else{
  //     return result.journeyList;
  //     // return result.journeyList?.filter(j => j!=null);
  //   }
  // }
  

  // public async getGroup(groupId:string,loadMembers?:boolean): Promise<GJData|null> {
  //   AppLogUtils.info(`getGroup groupID [${groupId}]`);
  //   //First, check if the user/group relation exists, and who is the leader
  //   const client = this.amplifyClient;
    
  //   const gResult = await client.models.GroupJourney.get(
  //       { id:groupId },
  //       { selectionSet: ['id','name', 'owner', 'ownerUserId', 'productId'] }
  //   );
  //   const group = Utils.getDataFromResult(gResult.data, gResult.errors, 'GroupJourney.get');
  //   if(group){
  //       let members:GJDataMember[]=[];
  //       if(loadMembers){
  //           const membersResult = await client.models.UserGroup.listUserGroupByGroupId(
  //               { groupId: groupId },
  //               { selectionSet: ['id','userId','member.sub','member.name','member.avatar'] }
  //           );
  //           const membersData = Utils.getDataFromResult(membersResult.data, membersResult.errors, 'UserGroup.listUserGroupByGroupId');
  //            // @ts-ignore
  //  members = membersData.map(m => {return { id:m.id,userId: m.userId, sub: m.member.sub, name:m.member.name??'',avatar:m.member.avatar??'' }});
  //       }
  //       return {id:group.id,name:group.name??'',owner:group.owner, ownerUserId: group.ownerUserId, members:members, productId: group.productId} as GJData;
  //   }else{
  //       return null;
  //   }
  // }



  /**
   * Updates the journey name by id (only allowed for owners)
   * @param groupId GroupJourney id
   * @param name new name
   * @returns the id of the updated journey
   */
  public async updateJourneyName(props:{groupId:string, name:string}): Promise<string>{
    console.log(`updateJourneyName [${props.groupId}]/[${props.name}]`);
    const result = await this.amplifyClient.models.GroupJourney.update(
      {
        id: props.groupId,
        name:props.name
      }
    );
    Utils.handleError(result,(`Error updating journey name by id`));
    if(result.data){return result.data.id}else{throw Error('undefined result Error updating journey name by id')};
  }

  public async removeMember(props:{userId:string,groupId:string}): Promise<JourneyOperationResult>{
    const request = {type:RequestType.REMOVE_MEMBER,userId:props.userId,groupId:props.groupId} as BackendRequest;
    const response = await this.sendRequest(request);
    return response.journeyOperResult??{}as JourneyOperationResult;
  }

  // public async getUserJourneysFromBackend(productId:string): Promise<JourneyOperationResult>{
  //   const request = {type:RequestType.GET_USER_JOURNEYS,productId:productId} as BackendRequest;
  //   const response = await this.sendRequest(request);
  //   return response.journeyOperResult??{} as JourneyOperationResult;
  // }

  public async createJourney(props:{name:string, productId:string}):Promise<GJData>{
    AppLogUtils.info(`createJourney`);
    const request = {type:RequestType.CREATE_JOURNEY,journeyName:props.name, productId:props.productId} as BackendRequest;
    const response = await this.sendRequest(request);
    
    if(!response.journeyOperResult){
      throw Error('No response from the server');
    }

    if(!response.journeyOperResult.journeyId){throw Error('No journey id returned from the server!');}

    if(response.journeyOperResult.success){
      const responseData = {
        id: response.journeyOperResult.journeyId,
        name:props.name
      }as GJData;
      return responseData;
    }else{
      throw Error(`Error creating journe => [${response.journeyOperResult.msg??''}]`);
    }
  }

  public async exitJourney(props:{userId:string,groupId:string}):Promise<JourneyOperationResult>{
    const request = {type:RequestType.EXIT_JOURNEY,userId:props.userId,groupId:props.groupId} as BackendRequest;
    const response = await this.sendRequest(request);
    return response.journeyOperResult??{}as JourneyOperationResult;

  }

  public async closeJourney(groupId:string):Promise<JourneyOperationResult>{
    const request = {type:RequestType.CLOSE_JOURNEY,groupId:groupId} as BackendRequest;
    const response = await this.sendRequest(request);
    return response.journeyOperResult??{}as JourneyOperationResult;
  }

  //##########################################################
  //##################### INVITATION #####################
  //##########################################################

  //----------------------------
  //---CREATE INVITE ---
  //----------------------------

  // public async createInvite(groupId:string):Promise<InviteOperationResult>{
  //   const request = {type:RequestType.CREATE_INVITE,groupId:groupId} as BackendRequest;
  //   const response = await this.sendRequest(request);
  //   return response.inviteOperResult??{}as InviteOperationResult;
  // }


  //----------------------------
  //---LOAD INVITE ---
  //----------------------------

  // public async loadInvite(inviteId:string):Promise<InviteOperationResult>{
  //   const request = {type:RequestType.RETRIEVE_INVITE,inviteId:inviteId} as BackendRequest;
  //   const response = await this.sendRequest(request);
  //   return response.inviteOperResult??{}as InviteOperationResult;;
  // }

  //----------------------------
  //---ACCEPT INVITE ---
  //----------------------------

  // public async acceptInvite(inviteId:string):Promise<InviteOperationResult>{
  //   const request = {type:RequestType.ACCEPT_INVITE,inviteId:inviteId} as BackendRequest;
  //   const response = await this.sendRequest(request);
  //   return response.inviteOperResult??{}as InviteOperationResult;;
  // }


  //##########################################################
  //##################### CHATS #####################
  //##########################################################

  //----------------------------
  //---LOAD CHAT MESSAGES ---
  //----------------------------

  public async loadChatMessages(groupId:string,chatId:string): Promise<ChatMessage[]>{
    const apiEndpoint = `${API_ENDPOINT}/group/messages?groupId=${groupId}&chatId=${chatId}`;
    const response = await ApiUtils.apiCall<
      {
        result: ApiResultTypes,
        messages:ChatMessage[]
      }
    >(
      'get',
      apiEndpoint,
    );
    if(response.result == ApiResultTypes.SUCCESS){
      return response.messages
    }else{
      return [];
    }
  }

  public async sendChatMessage(groupId:string,chatId:string,content:string): Promise<boolean>{
    const apiEndpoint = `${API_ENDPOINT}/group/messages`;
    const response = await ApiUtils.apiCall<
      {
        result: ApiResultTypes,
        messages:ChatMessage[]
      }
    >(
      'post',
      apiEndpoint,
      {
        groupId: groupId,
        chatId: chatId,
        content: content
      }
    );
    return response.result == ApiResultTypes.SUCCESS
  }



  // public async loadChatMessages(groupId:string,chatId:string):Promise<ChatOperationResult>{
  //   const request = {type:RequestType.READ_CHAT_MESSAGES,groupId:groupId, chatId: chatId} as BackendRequest;
  //   const response = await this.sendRequest(request);
  //   console.log('Load chats response',response);
  //   return response.chatOperResult??{}as ChatOperationResult;
  // }
  
  //----------------------------
  //---SEND CHAT MESSAGES ---
  //----------------------------

  // public async sendChatMessage(groupId:string,chatId:string,content:string):Promise<JourneyChatMessage|null>{
  //   const request = {type:RequestType.SEND_CHAT_MESSAGE,groupId:groupId, chatId:chatId, content:content} as BackendRequest;
  //   const response = await this.sendRequest(request);
  //   if(response.success){
  //     if(response.chatOperResult?.messages && response.chatOperResult.messages.length==1){
  //       return response.chatOperResult.messages[0] as JourneyChatMessage;
  //     }
  //   }
  //   return null;
  // }

  private async sendRequest(request:BackendRequest):Promise<BackendResponse>{
    const response = await this.amplifyClient.queries.journeyFunctions({request:JSON.stringify(request)});
    const responseData = Utils.getDataFromResult(response.data,response.errors,`Error => ${request.type}`);
    if(!responseData) throw `Could not ${request.type} => null`;
    // console.log('Response data =>',responseData);
    let jsonObj;
    try{
      jsonObj = JSON.parse(responseData);
    }catch(err){
      console.log(err);
    }

    return jsonObj as BackendResponse;
  }

  // private getTypedResult(result:any):JourneyOperationResult {
  //   const str = result as string;
  //   const obj = JSON.parse(str);
  //   return obj as JourneyOperationResult;
  // }
}
